import { useState, useEffect, useRef } from "react";
import photo0 from './photos/lassi.png';
import photo1 from './photos/unnamed1.webp';
import photo2 from './photos/unnamed2.webp';
import photo3 from './photos/unnamed3.webp';
import photo4 from './photos/unnamed4.webp';
import photo5 from './photos/unnamed5.webp';
import photo6 from './photos/unnamed6.webp';
import photo7 from './photos/unnamed7.webp';
import photo8 from './photos/unnamed8.webp';
import photo9 from './photos/unnamed9.webp';
import photo10 from './photos/unnamed10.webp';
import photo11 from './photos/ratechart.png';
import logo from './photos/logo.png';

const menuItems = [
    {
        category: "🍽️ Snacks",
        items: [
            { name: "Idli Ghugni", desc: "Soft steamed idli with spiced ghuguni — hearty & filling", price: "₹40", icon: "🥘", popular: false },

            { name: "Puri Ghuguni", desc: "Fluffy puri served with spiced white pea curry (ghuguni)", price: "₹50", icon: "🫓", popular: true },

            { name: "Upma Ghugni", desc: "Warm suji upma paired with tangy ghuguni", price: "₹50", icon: "🍚", popular: false },

            { name: "Puri Upma", desc: "Soft puri served alongside classic suji upma", price: "₹75", icon: "🍽️", popular: false },

            { name: "Puri Idli", desc: "Puri and fluffy steamed idli combo", price: "₹75", icon: "🫓", popular: false },

            { name: "Idli Bara", desc: "Steamed idli with fresh Odia bara on the side", price: "₹75", icon: "🍱", popular: false },

            { name: "Bara", desc: "Classic Odia lentil fritter — crispy outside, soft inside", price: "₹15", icon: "🫓", popular: false },

            { name: "Aloo Chop", desc: "Golden spiced potato chop, perfectly fried", price: "₹15", icon: "🥔", popular: false },

            { name: "Piaji", desc: "Crispy onion fritters, Odia-style pakora", price: "₹15", icon: "🧅", popular: true },

            { name: "Bread Chop", desc: "Bread stuffed with spiced filling, deep fried to golden perfection", price: "₹25", icon: "🍞", popular: false },

            { name: "Gulugula", desc: "Sweet fried wheat-based balls — a beloved street classic", price: "₹15", icon: "🟡", popular: false },

            { name: "Cutlet", desc: "Spiced vegetable cutlet, pan-fried and crispy", price: "₹20", icon: "🍘", popular: false },

            { name: "Kachori", desc: "Flaky pastry stuffed with spiced lentil filling", price: "₹25", icon: "🥮", popular: false },

            { name: "Dahi Kachori", desc: "Kachori topped with creamy dahi, chutneys and sev", price: "₹30", icon: "🥣", popular: true },

            { name: "Samosa", desc: "Crispy pastry filled with spiced potato & peas", price: "₹20", icon: "🥟", popular: true },

            { name: "Chakuli", desc: "Soft Odia rice crepe, light and delicious", price: "₹40", icon: "🫔", popular: false },

            { name: "Dahi Bara Aloo Dum", desc: "Our signature! Dahi vada with spicy potato curry, sev & onions", price: "₹70", icon: "🥣", popular: true },

            { name: "Chole Samosa", desc: "Samosa dunked in spiced masala gravy with chutneys", price: "₹35", icon: "🥟", popular: true },

            { name: "Odisha Chaat", desc: "Classic Odia chaat with chutneys, sev and tangy toppings", price: "₹80", icon: "🫙", popular: true },

            { name: "Samosa Chat", desc: "Crispy samosa topped with curd, chutneys and sev", price: "₹100", icon: "🥟", popular: true },

            { name: "Dahi Bara Chat", desc: "Dahi bara elevated with chaat toppings — sweet, tangy & spicy", price: "₹80", icon: "🥣", popular: true },

            { name: "Ghuguni 1 Plate", desc: "A generous plate of our signature spiced white pea curry", price: "₹20", icon: "🥣", popular: false },

            { name: "Aloo Dum 1 Plate", desc: "Spicy potato curry cooked Odia style — comfort in a plate", price: "₹20", icon: "🥔", popular: false },

            { name: "Kakra 1 Pics", desc: "Traditional Odia kakra — crispy and delicious", price: "₹25", icon: "🟤", popular: false },

            { name: "Normal Samosa Chat", desc: "Classic samosa chat with chutneys and sev", price: "₹50", icon: "🥟", popular: false },
        ],
    },

    {
        category: "🍬 Sweets",
        items: [
            { name: "Chhena Poda 100gm", desc: "Odisha's iconic baked cottage cheese dessert — caramelised & rich", price: "₹70", icon: "🍮", popular: true },

            { name: "White Rasgulla 1pc", desc: "Spongy cottage cheese ball soaked in light sugar syrup", price: "₹25", icon: "⚪", popular: true },

            { name: "Pahala Rasgulla 1pc", desc: "Famous Pahala-style rasgulla — softer and more aromatic", price: "₹25", icon: "🟡", popular: true },

            { name: "Gulab Jamun 1pc", desc: "Soft milk-solid dumplings soaked in rose-flavoured syrup", price: "₹25", icon: "🟤", popular: false },

            { name: "Kala Jamun 1pc", desc: "Dark, deep-fried gulab jamun with a denser texture", price: "₹25", icon: "⚫", popular: false },

            { name: "Langacha 1pc", desc: "Unique Bengali-style elongated khoya sweet", price: "₹30", icon: "🟠", popular: false },

            { name: "Malpua 1pc", desc: "Soft fried pancake soaked in sugar syrup — festive classic", price: "₹20", icon: "🥞", popular: false },

            { name: "Puri Khaja 1pc", desc: "Flaky, crispy layered sweet — Odia temple delicacy", price: "₹20", icon: "🍪", popular: false },

            { name: "Laddu 1pc", desc: "Round sweet ball made from gram flour — festive favourite", price: "₹20", icon: "🟡", popular: false },

            { name: "Chhena Gaja 1pc", desc: "Deep-fried cottage cheese sweet soaked in sugar syrup", price: "₹35", icon: "🟨", popular: false },

            { name: "Rajbhog 1pc", desc: "Large saffron-stuffed rasgulla — royal and indulgent", price: "₹50", icon: "🟡", popular: true },

            { name: "Rabdi 1 Cup", desc: "Thick reduced milk dessert with saffron and cardamom", price: "₹75", icon: "🥛", popular: false },

            { name: "Rasmalai 1 Cup", desc: "Soft chenna patties in creamy saffron milk", price: "₹60", icon: "🍶", popular: true },

            { name: "Sweet Bundi 100gm", desc: "Tiny sweet gram flour pearls, perfect for prasad or snacking", price: "₹40", icon: "🟠", popular: false },

            { name: "Sev Bundi 1 Plate", desc: "Savoury sev paired with sweet bundi — a classic mix", price: "₹60", icon: "🟡", popular: false },

            { name: "Dahi Bundi 1 Plate", desc: "Bundi soaked in creamy seasoned yoghurt with chutneys", price: "₹50", icon: "🥣", popular: false },

            { name: "Jaggery Poda 100gm", desc: "Earthy, caramel-rich baked sweet made with jaggery", price: "₹80", icon: "🟫", popular: false },

            { name: "Khastha Gaja 1Pic", desc: "Crispy, flaky Odia sweet — light and melt-in-mouth", price: "₹20", icon: "🍘", popular: false },

            { name: "Rasa Boli 2Pic", desc: "Soft chenna discs soaked in sweetened coconut milk", price: "₹60", icon: "⚪", popular: false },

            { name: "Labanga Lata 1 Pic", desc: "Clove-pinned pastry stuffed with coconut & khoya filling", price: "₹20", icon: "🌿", popular: false },

            { name: "Lancha 1 Pic", desc: "Elongated deep-fried khoya sweet soaked in syrup", price: "₹25", icon: "🟤", popular: false },

            { name: "Nimki 1 Pic", desc: "Crispy savoury fried pastry — perfect tea-time snack", price: "₹15", icon: "🔷", popular: false },

            { name: "Namkin 100gm", desc: "Assorted savoury namkeen mix", price: "₹35", icon: "🟡", popular: false },

            { name: "Bhujia 100gm", desc: "Thin crispy sev — spicy and addictive", price: "₹40", icon: "🟠", popular: false },

            { name: "Loose Paneer 100gm", desc: "Fresh soft cottage cheese, made in-house daily", price: "₹80", icon: "⬜", popular: false },

            { name: "Odisha Lassi", desc: "Thick chilled yoghurt drink, Odia-style refreshment", price: "₹100", icon: "🥛", popular: true },

            { name: "Rabdi Lassi", desc: "Lassi layered with creamy rabdi — rich and indulgent", price: "₹130", icon: "🍶", popular: true },
        ],
    },
];
const reviewers = [
    {
        handle: "@rasoisaga", platform: "YouTube / Instagram", color: "#E1306C", icon: "📸",
        likes: "6.3M", comments: "39",
        quote: "A tiny gem in the lanes of BTM layout — a must visit for snacks + sweets! Don't miss Chenna Poda, Gurer Roshogolla and Samosas here! 😍🙌",
        tags: ["#odiafood", "#odiafoodinbangalore", "#bangalorefoodie", "#btmlayout"],
        videoSrc: "https://www.youtube.com/embed/Ofjp5Svhq40",
        videoTitle: "Dahibara Aloodum – Rasoisaga",
    },
    {
        handle: "@thatfoodfreak", platform: "Instagram Reel", color: "#FF6B00", icon: "🍴",
        likes: "54.8K", comments: "906",
        quote: "This is a small Odia shop serving a variety of Odia snacks & sweets. It's a must visit if you are nearby BTM! Best Chenna Poda in Bangalore 🏆",
        tags: ["#odia", "#dahibara", "#chennapoda", "#reelkarofeelkaro"],
        videoSrc: "https://www.youtube.com/embed/tLYgxskuJUo",
        videoTitle: "Best ChennaPoda in Bangalore – that_food_freak",
    },
];

const photos = [
    { src: photo0 },{ src: photo1 }, { src: photo2 }, { src: photo3 }, { src: photo4 },
    { src: photo5 }, { src: photo6 }, { src: photo7 }, { src: photo8 },
    { src: photo9 }, { src: photo10 }, { src: photo11 },
];

const customerReviews = [
    { name: "Sasmita Monahari", rating: 5, text: "It was a great experience, and the food is tasty and affordable. Must try their Upma with Aloo Matar curry, Vada, Idli, Chutney, and Gulugula. If you're looking for authentic Odia food, this place is not to be missed. I visit regularly on weekends to satisfy my Odia soul. ❤️", avatar: "S" },
    { name: "Gourab Jena", rating: 5, text: "I have tried many places Dahibara in BLR but this is something remind me of our own Odia Dahibara. If you are living nearby must go place! Bara and ghuguni was brilliant as well.!!", avatar: "G" },
    { name: "Ipsita Mohanty", rating: 4, text: "Very nice taste as we love the food it's awesome feel like odisha in Bangalore.", avatar: "I" },
    { name: "Pratisha Swain", rating: 5, text: "Very nice Dahibara aloodum. Tried twice on different days. Both times it was good. Vegetable chop, Aloo chop, rasagulla were also good. I wish for them to grow but should not change the taste.! 😍", avatar: "P" },
    { name: "jyotirmoy", rating: 5, text: "May be the shop is small but you will get all types of snacks with super taste. Awesome 👍👍👍", avatar: "J" },
];

const WA_LINK = "https://wa.me/918249079497?text=Hi%2C%20I%20want%20to%20place%20a%20bulk%20order";

/* ── GLOBAL CSS ── */
const G = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=Lato:wght@300;400;700&display=swap');
*{margin:0;padding:0;box-sizing:border-box;}
html{-webkit-text-size-adjust:100%;}
:root{--sf:#FF6B00;--dark:#1a0a00;--cream:#FFF8F0;}
body{scroll-behavior:smooth;font-family:'Lato',sans-serif;background:var(--cream);overflow-x:hidden;}

/* NAV */
.nav-link{background:none;border:none;cursor:pointer;font-family:'Lato',sans-serif;
  font-size:.82rem;letter-spacing:.1em;text-transform:uppercase;color:white;
  padding:5px 12px;border-bottom:2px solid transparent;transition:all .2s;white-space:nowrap;}
.nav-link:hover,.nav-link.active{border-bottom:2px solid #FF6B00;color:#FF6B00;}
.mobile-nav{position:fixed;top:68px;left:0;right:0;background:rgba(26,10,0,.98);
  z-index:999;display:flex;flex-direction:column;padding:12px 0 20px;
  box-shadow:0 8px 24px rgba(0,0,0,.4);border-top:1px solid rgba(255,107,0,.2);}
.mobile-nav .nav-link{padding:14px 24px;border-bottom:none;border-left:3px solid transparent;font-size:.95rem;text-align:left;}
.mobile-nav .nav-link.active,.mobile-nav .nav-link:hover{border-left:3px solid #FF6B00;color:#FF6B00;background:rgba(255,107,0,.06);}
.hamburger{background:none;border:none;cursor:pointer;padding:6px;display:flex;flex-direction:column;gap:5px;}
.hamburger span{display:block;width:24px;height:2px;background:white;border-radius:2px;transition:all .3s;}
.hamburger.open span:nth-child(1){transform:rotate(45deg) translate(5px,5px);}
.hamburger.open span:nth-child(2){opacity:0;}
.hamburger.open span:nth-child(3){transform:rotate(-45deg) translate(5px,-5px);}

/* STANDARD BUTTONS */
.btn-sf{background:#FF6B00;color:white;border:none;padding:13px 28px;font-size:.92rem;
  font-family:'Lato',sans-serif;font-weight:700;letter-spacing:.08em;cursor:pointer;
  border-radius:4px;text-transform:uppercase;transition:all .2s;
  box-shadow:0 4px 14px rgba(255,107,0,.35);}
.btn-sf:hover{background:#e55a00;transform:translateY(-2px);}
.btn-sf:active{transform:translateY(0);}
.btn-outline{background:transparent;color:white;border:2px solid white;padding:11px 24px;
  font-size:.92rem;font-family:'Lato',sans-serif;font-weight:700;letter-spacing:.08em;
  cursor:pointer;border-radius:4px;text-transform:uppercase;transition:all .2s;}
.btn-outline:hover{background:white;color:#FF6B00;}

/* ── INLINE BUTTONS: always visible on ALL screen sizes ── */
.btn-call{
  background:#FF6B00;color:white;border:none;border-radius:4px;
  padding:13px 20px;font-family:'Lato',sans-serif;font-weight:700;font-size:.9rem;
  box-shadow:0 4px 14px rgba(255,107,0,.35);cursor:pointer;width:100%;
  display:flex;align-items:center;justify-content:center;gap:8px;
  text-transform:uppercase;letter-spacing:.06em;transition:all .2s;}
.btn-call:hover{background:#e55a00;transform:translateY(-2px);}
.btn-wa{
  background:#25D366;color:white;border:none;border-radius:4px;
  padding:13px 20px;font-family:'Lato',sans-serif;font-weight:700;font-size:.9rem;
  box-shadow:0 4px 14px rgba(37,211,102,.35);cursor:pointer;width:100%;
  display:flex;align-items:center;justify-content:center;gap:8px;
  text-transform:uppercase;letter-spacing:.06em;transition:all .2s;}
.btn-wa:hover{background:#1ebe5a;transform:translateY(-2px);}

/* TABS */
.tab-btn{background:none;border:2px solid #e0d0c0;cursor:pointer;font-family:'Lato',sans-serif;
  font-weight:700;font-size:.85rem;padding:9px 18px;border-radius:30px;transition:all .2s;color:#666;}
.tab-btn.active{background:#FF6B00;border-color:#FF6B00;color:white;}

/* CARDS */
.review-card{background:white;border-radius:12px;padding:20px;box-shadow:0 2px 14px rgba(0,0,0,.07);}
.reviewer-card{background:white;border-radius:16px;overflow:hidden;box-shadow:0 4px 24px rgba(0,0,0,.09);transition:all .25s;}
.reviewer-card:hover{transform:translateY(-3px);box-shadow:0 10px 36px rgba(0,0,0,.13);}
.info-row{display:flex;align-items:flex-start;gap:13px;background:white;border-radius:11px;padding:16px;box-shadow:0 2px 10px rgba(0,0,0,.06);}

/* VIDEO */
.video-wrap{position:relative;padding-bottom:56.25%;height:0;overflow:hidden;}
.video-wrap iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:0;}

/* SLIDER */
.slide-btn{background:rgba(255,255,255,.9);border:none;cursor:pointer;width:40px;height:40px;
  border-radius:50%;font-size:1.1rem;display:flex;align-items:center;justify-content:center;
  box-shadow:0 2px 10px rgba(0,0,0,.15);transition:all .2s;line-height:1;-webkit-tap-highlight-color:transparent;}
.slide-btn:hover{background:white;transform:scale(1.08);}
.dot{width:8px;height:8px;border-radius:50%;border:none;cursor:pointer;padding:0;
  background:rgba(255,255,255,.35);transition:all .2s;-webkit-tap-highlight-color:transparent;}
.dot.on{background:white;transform:scale(1.35);}
.slider-main-img{display:block;width:100%;height:auto;max-height:620px;object-fit:contain;background:#111;transition:opacity .5s ease;}
.thumb-strip{display:flex;background:#1a0a00;overflow-x:auto;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;gap:3px;padding:3px;}
.thumb-strip::-webkit-scrollbar{height:4px;}
.thumb-strip::-webkit-scrollbar-track{background:#111;}
.thumb-strip::-webkit-scrollbar-thumb{background:#FF6B00;border-radius:2px;}
.thumb-item{flex:0 0 auto;width:80px;height:60px;cursor:pointer;overflow:hidden;border:2px solid transparent;transition:border-color .2s,opacity .2s;border-radius:4px;}
.thumb-item img{width:100%;height:100%;object-fit:cover;display:block;}
.thumb-item.active-thumb{border-color:#FF6B00;}
.thumb-item:not(.active-thumb){opacity:.5;}
.thumb-item:hover{opacity:.85;}

/* FAB — floating buttons, mobile ONLY */
.fab-call{display:none;position:fixed;bottom:20px;right:20px;z-index:900;
  background:#FF6B00;color:white;border:none;border-radius:50px;
  padding:14px 20px;font-family:'Lato',sans-serif;font-weight:700;font-size:.88rem;
  box-shadow:0 4px 20px rgba(255,107,0,.5);cursor:pointer;
  align-items:center;gap:8px;-webkit-tap-highlight-color:transparent;}
.fab-wa{display:none;position:fixed;bottom:80px;right:20px;z-index:900;
  background:#25D366;color:white;border:none;border-radius:50px;
  padding:14px 20px;font-family:'Lato',sans-serif;font-weight:700;font-size:.88rem;
  box-shadow:0 4px 20px rgba(37,211,102,.5);cursor:pointer;
  align-items:center;gap:8px;-webkit-tap-highlight-color:transparent;}

/* TYPOGRAPHY */
.slabel{font-family:'Lato',sans-serif;font-weight:700;letter-spacing:.2em;text-transform:uppercase;font-size:.74rem;color:#FF6B00;margin-bottom:8px;}
.stitle{font-family:'Playfair Display',serif;font-size:clamp(1.65rem,5vw,2.7rem);font-weight:900;line-height:1.1;color:#1a0a00;}
.divider{width:52px;height:4px;background:#FF6B00;border-radius:2px;margin:13px 0 28px;}
.avatar{width:40px;height:40px;border-radius:50%;background:#FF6B00;color:white;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:1rem;flex-shrink:0;}
.star{color:#FFB800;}
.tag{display:inline-block;background:#FFF3E0;color:#FF6B00;font-size:.7rem;padding:2px 9px;border-radius:20px;margin:2px;font-weight:700;}

/* ANIMATIONS */
.fade{animation:fu .8s ease forwards;opacity:0;}
.fd1{animation-delay:.15s;}.fd2{animation-delay:.3s;}.fd3{animation-delay:.45s;}
@keyframes fu{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}

/* LAYOUT */
.grid-reviewer{display:grid;grid-template-columns:1fr 1fr;gap:24px;}
.grid-reviews{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:14px;}
.grid-contact{display:grid;grid-template-columns:1fr 1.55fr;gap:24px;align-items:start;}
.info-strip{display:flex;justify-content:center;gap:32px;flex-wrap:wrap;}
.hero-stats{display:flex;gap:28px;justify-content:center;flex-wrap:wrap;}
.hero-btns{display:flex;gap:12px;justify-content:center;flex-wrap:wrap;}
.stat-banner{display:flex;flex-wrap:wrap;gap:16px;justify-content:space-around;align-items:center;}
.tab-row{display:flex;gap:10px;justify-content:center;flex-wrap:wrap;}
.price-badge{display:inline-block;background:#FF6B00;color:white;font-weight:700;font-size:.88rem;padding:3px 10px;border-radius:6px;white-space:nowrap;min-width:44px;text-align:center;}

/* LOGO */
.nav-logo{height:52px;width:auto;object-fit:contain;filter:drop-shadow(0 2px 6px rgba(0,0,0,.35));transition:transform .2s;}
.nav-logo:hover{transform:scale(1.05);}
.hero-logo{height:clamp(130px,26vw,210px);width:auto;object-fit:contain;filter:drop-shadow(0 8px 24px rgba(0,0,0,.5));}
.footer-logo{height:72px;width:auto;object-fit:contain;filter:drop-shadow(0 2px 8px rgba(0,0,0,.4));}

/* MOBILE ≤ 640px */
@media(max-width:640px){
  .grid-reviewer{grid-template-columns:1fr;}
  .grid-contact{grid-template-columns:1fr;}
  .nav-desktop{display:none!important;}
  .hamburger{display:flex!important;}
  .fab-call{display:flex;}
  .fab-wa{display:flex;}
  .info-strip{gap:18px;}
  .hero-stats{gap:18px;}
  .hero-btns{flex-direction:column;align-items:center;}
  .hero-btns .btn-sf,.hero-btns .btn-outline{width:100%;max-width:280px;text-align:center;}
  .tab-btn{font-size:.8rem;padding:8px 14px;}
  .map-box{height:280px!important;}
  .stat-banner{gap:12px;}
  .nav-logo{height:42px;}
  .hero-logo{height:clamp(110px,38vw,160px);}
  .thumb-item{width:60px;height:46px;}
  .slider-main-img{max-height:340px;}
  body{padding-bottom:150px;background:#0f0500;}
}

/* TABLET ≤ 900px */
@media(max-width:900px){
  .grid-reviewer{grid-template-columns:1fr;}
  .grid-contact{grid-template-columns:1fr;}
  .nav-desktop{display:none!important;}
  .hamburger{display:flex!important;}
  .fab-call{display:flex;}
  .fab-wa{display:flex;}
  .map-box{height:320px!important;}
  .nav-logo{height:46px;}
  .slider-main-img{max-height:480px;}
  body{padding-bottom:150px;background:#0f0500;}
}

/* DESKTOP ≥ 901px — hide FABs, show inline buttons */
@media(min-width:901px){
  .hamburger{display:none!important;}
  .mobile-menu-open{display:none!important;}
  .fab-call{display:none!important;}
  .fab-wa{display:none!important;}
  body{padding-bottom:0;}
}
`;

/* ── PHOTO SLIDER ── */
function PhotoSlider() {
    const [cur, setCur] = useState(0);
    const timer = useRef(null);
    const touchX = useRef(null);
    const thumbRef = useRef(null);

    const go = (dir) => setCur(c => (c + dir + photos.length) % photos.length);

    const goTo = (i) => {
        setCur(i);
        if (thumbRef.current) {
            const el = thumbRef.current.children[i];
            if (el) {
                thumbRef.current.scrollLeft = el.offsetLeft - thumbRef.current.offsetWidth / 2 + el.offsetWidth / 2;
            }
        }
    };

    useEffect(() => {
        timer.current = setInterval(() => setCur(c => (c + 1) % photos.length), 4200);
        return () => clearInterval(timer.current);
    }, []);

    useEffect(() => {
        if (thumbRef.current) {
            const el = thumbRef.current.children[cur];
            if (el) {
                thumbRef.current.scrollLeft = el.offsetLeft - thumbRef.current.offsetWidth / 2 + el.offsetWidth / 2;
            }
        }
    }, [cur]);

    const onTouchStart = (e) => { touchX.current = e.touches[0].clientX; };
    const onTouchEnd = (e) => {
        if (touchX.current === null) return;
        const diff = touchX.current - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) go(diff > 0 ? 1 : -1);
        touchX.current = null;
    };

    return (
        <div style={{ borderRadius: 14, overflow: "hidden", boxShadow: "0 6px 28px rgba(0,0,0,.22)", background: "#111" }}>
            <div style={{ position: "relative", background: "#111", touchAction: "pan-y" }} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
                <div style={{ position: "relative" }}>
                    {photos.map((p, i) => (
                        <img key={i} src={p.src} alt={`New Odia Snacks and Sweets - slide ${i + 1}`} className="slider-main-img"
                            style={{ position: i === cur ? "relative" : "absolute", top: 0, left: 0, opacity: i === cur ? 1 : 0, zIndex: i === cur ? 1 : 0 }} />
                    ))}
                </div>
                <div style={{ position: "absolute", bottom: 12, left: 0, right: 0, zIndex: 10, display: "flex", justifyContent: "center", gap: 6 }}>
                    {photos.map((_, i) => (
                        <button key={i} className={`dot ${i === cur ? "on" : ""}`} onClick={() => goTo(i)} />
                    ))}
                </div>
                <button className="slide-btn" onClick={() => go(-1)} style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", zIndex: 10 }}>‹</button>
                <button className="slide-btn" onClick={() => go(1)} style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", zIndex: 10 }}>›</button>
                <div style={{ position: "absolute", top: 12, right: 14, zIndex: 10, background: "rgba(0,0,0,.55)", color: "white", borderRadius: 20, fontSize: ".72rem", padding: "3px 10px", fontWeight: 700 }}>
                    {cur + 1} / {photos.length}
                </div>
            </div>
            <div className="thumb-strip" ref={thumbRef}>
                {photos.map((p, i) => (
                    <div key={i} className={`thumb-item ${i === cur ? "active-thumb" : ""}`} onClick={() => goTo(i)}>
                        <img src={p.src} alt={`Thumbnail ${i + 1}`} />
                    </div>
                ))}
            </div>
        </div>
    );
}

/* ── MAIN APP ── */
export default function App() {
    const [activeSection, setSection] = useState("home");
    const [activeCategory, setCat] = useState(0);
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const fn = () => {
            setScrolled(window.scrollY > 55);
            if (window.scrollY > 55 && menuOpen) setMenuOpen(false);
        };
        window.addEventListener("scroll", fn);
        return () => window.removeEventListener("scroll", fn);
    }, [menuOpen]);

    useEffect(() => {
        if (!menuOpen) return;
        const fn = (e) => { if (!e.target.closest(".nav-root")) setMenuOpen(false); };
        document.addEventListener("click", fn);
        return () => document.removeEventListener("click", fn);
    }, [menuOpen]);

    const go = (id) => {
        setSection(id);
        setMenuOpen(false);
        setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 50);
    };

    const navLinks = ["home", "gallery", "menu", "featured", "contact"];

    return (
        <div>
            <style>{G}</style>

            {/* ── FLOATING BUTTONS — mobile only (hidden on desktop via CSS) ── */}
            <a href="tel:08249079497" style={{ textDecoration: "none" }}>
                <button className="fab-call">📞 Call Now</button>
            </a>
            <a href={WA_LINK} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                <button className="fab-wa">💬 WhatsApp</button>
            </a>

            {/* ── NAVBAR ── */}
            <nav className="nav-root" style={{
                position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000,
                background: scrolled ? "rgba(26,10,0,.97)" : "rgba(26,10,0,.85)",
                backdropFilter: "blur(10px)", transition: "background .3s",
                boxShadow: scrolled ? "0 2px 18px rgba(0,0,0,.3)" : "none", padding: "0 16px",
            }}>
                <div style={{ maxWidth: 1140, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", height: 68 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }} onClick={() => go("home")}>
                        <img src={logo} alt="New Odia Snacks & Sweets" className="nav-logo" />
                        <div>
                            <div style={{ fontFamily: "'Playfair Display',serif", fontWeight: 900, color: "white", fontSize: ".92rem", lineHeight: 1.1 }}>New Odia</div>
                            <div style={{ fontSize: ".55rem", color: "#FF6B00", letterSpacing: ".2em", textTransform: "uppercase" }}>Snacks & Sweets</div>
                        </div>
                    </div>
                    <div className="nav-desktop" style={{ display: "flex", gap: 2 }}>
                        {navLinks.map(s => (
                            <button key={s} className={`nav-link ${activeSection === s ? "active" : ""}`} onClick={() => go(s)}>{s}</button>
                        ))}
                    </div>
                    <button className={`hamburger ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
                        <span /><span /><span />
                    </button>
                </div>

                {menuOpen && (
                    <div className="mobile-nav">
                        {navLinks.map(s => (
                            <button key={s} className={`nav-link ${activeSection === s ? "active" : ""}`} onClick={() => go(s)}>
                                {s === "home" ? "🏠 Home" : s === "gallery" ? "🖼️ Gallery" : s === "menu" ? "🍽️ Menu" : s === "featured" ? "🎬 Featured" : "📍 Contact"}
                            </button>
                        ))}
                        <div style={{ margin: "12px 24px 0", display: "flex", gap: 10 }}>
                            <a href="tel:08249079497" style={{ textDecoration: "none", flex: 1 }}>
                                <button className="btn-sf" style={{ width: "100%", padding: "12px" }}>📞 Call Now</button>
                            </a>
                            <a href={WA_LINK} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", flex: 1 }}>
                                <button className="btn-wa" style={{ padding: "12px" }}>💬 WhatsApp</button>
                            </a>
                        </div>
                    </div>
                )}
            </nav>

            {/* ── HERO ── */}
            <section id="home" style={{
                minHeight: "100svh",
                background: "linear-gradient(135deg,#1a0a00 0%,#3d1500 40%,#6b2800 70%,#8B1A00 100%)",
                display: "flex", alignItems: "center", justifyContent: "center",
                position: "relative", overflow: "hidden", padding: "100px 20px 60px",
            }}>
                <div style={{ position: "absolute", top: "-8%", right: "-4%", width: "min(460px,80vw)", height: "min(460px,80vw)", borderRadius: "50%", background: "rgba(255,107,0,.07)", pointerEvents: "none" }} />
                <div style={{ position: "absolute", bottom: "-12%", left: "-6%", width: "min(360px,70vw)", height: "min(360px,70vw)", borderRadius: "50%", background: "rgba(212,160,23,.06)", pointerEvents: "none" }} />
                <div style={{ maxWidth: 800, textAlign: "center", position: "relative", width: "100%" }}>
                    <div className="fade" style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
                        <img src={logo} alt="New Odia Snacks & Sweets" className="hero-logo" />
                    </div>
                    <p className="fade" style={{ fontSize: ".78rem", letterSpacing: ".3em", color: "#FF6B00", textTransform: "uppercase", marginBottom: 12 }}>✦ Authentic Flavours of Odisha ✦</p>
                    <h1 className="fade fd1" style={{ fontFamily: "'Playfair Display',serif", fontWeight: 900, fontSize: "clamp(2.4rem,9vw,5rem)", color: "white", lineHeight: 1.05, marginBottom: 18 }}>
                        New Odia<br /><span style={{ color: "#FF6B00" }}>Snacks &</span><br />Sweets
                    </h1>
                    <p className="fade fd2" style={{ fontSize: "clamp(.9rem,2.5vw,1.05rem)", color: "rgba(255,255,255,.72)", lineHeight: 1.75, maxWidth: 500, margin: "0 auto 32px" }}>
                        Bringing the heartwarming taste of Odisha to Bengaluru. From crispy Dahibara Aloodum to melt-in-your-mouth Chhenapoda — every bite is home.
                    </p>
                    <div className="fade fd3 hero-btns">
                        <button className="btn-sf" onClick={() => go("menu")}>View Menu</button>
                        <button className="btn-outline" onClick={() => go("featured")}>🎬 Seen Online</button>
                        <button className="btn-outline" onClick={() => go("contact")}>📍 Find Us</button>
                    </div>
                    <div className="fade fd3 hero-stats" style={{ marginTop: 40 }}>
                        {[["4.2★", "Google Rating"], ["401+", "Reviews"], ["54.8K", "Youtube & Insta Likes"], ["₹10–200", "Price Range"]].map(([v, l]) => (
                            <div key={l} style={{ textAlign: "center" }}>
                                <div style={{ fontFamily: "'Playfair Display',serif", fontSize: "clamp(1.2rem,4vw,1.5rem)", color: "#FF6B00", fontWeight: 700 }}>{v}</div>
                                <div style={{ fontSize: ".66rem", color: "rgba(255,255,255,.45)", letterSpacing: ".08em", textTransform: "uppercase" }}>{l}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── INFO STRIP ── */}
            <div style={{ background: "#FF6B00", padding: "18px 20px" }}>
                <div className="info-strip" style={{ maxWidth: 1140, margin: "0 auto" }}>
                    {[["🕙", "8am–3pm & 5pm–10pm", "Daily"], ["📍", "BTM Layout 2nd Stage", "Bengaluru 560076"], ["📞", "082490 79497", "Call us"], ["💰", "₹10–₹200", "Very affordable"]].map(([icon, t, s]) => (
                        <div key={t} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{ fontSize: "1.3rem" }}>{icon}</span>
                            <div>
                                <div style={{ fontWeight: 700, color: "white", fontSize: ".88rem" }}>{t}</div>
                                <div style={{ color: "rgba(255,255,255,.78)", fontSize: ".72rem" }}>{s}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* ── PHOTO GALLERY ── */}
            <section id="gallery" style={{ padding: "64px 20px", background: "#1a0a00" }}>
                <div style={{ maxWidth: 1100, margin: "0 auto" }}>
                    <div style={{ textAlign: "center", marginBottom: 38 }}>
                        <div className="slabel">Photo Gallery</div>
                        <h2 className="stitle" style={{ color: "white" }}>A Peek Inside<br />Our Little Shop</h2>
                        <div className="divider" style={{ margin: "12px auto 0" }} />
                    </div>
                    <PhotoSlider />
                </div>
            </section>

            {/* ── MENU ── */}
            <section id="menu" style={{ padding: "64px 20px", background: "#FFF8F0", backgroundImage: "repeating-linear-gradient(45deg,transparent,transparent 10px,rgba(255,107,0,.02) 10px,rgba(255,107,0,.02) 20px)" }}>
                <div style={{ maxWidth: 1140, margin: "0 auto" }}>
                    <div style={{ textAlign: "center", marginBottom: 38 }}>
                        <div className="slabel">Our Offerings</div>
                        <h2 className="stitle">Our Full Menu</h2>
                        <div className="divider" style={{ margin: "12px auto 24px" }} />
                        <p style={{ color: "#666", fontSize: ".96rem", maxWidth: 460, margin: "0 auto" }}>All prices direct from our menu board — authentic Odia taste at unbeatable prices!</p>
                    </div>
                    <div className="tab-row" style={{ marginBottom: 30 }}>
                        {menuItems.map((cat, i) => (
                            <button key={i} className={`tab-btn ${activeCategory === i ? "active" : ""}`} onClick={() => setCat(i)}>{cat.category}</button>
                        ))}
                    </div>
                    <div style={{ background: "white", borderRadius: 16, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,.08)" }}>
                        <div style={{ background: "#1a0a00", display: "flex", padding: "14px 20px", alignItems: "center" }}>
                            <div style={{ flex: 1, fontFamily: "'Lato',sans-serif", fontWeight: 700, fontSize: ".78rem", letterSpacing: ".15em", textTransform: "uppercase", color: "#FF6B00" }}>Item</div>
                            <div style={{ fontFamily: "'Lato',sans-serif", fontWeight: 700, fontSize: ".78rem", letterSpacing: ".15em", textTransform: "uppercase", color: "#FF6B00", minWidth: 60, textAlign: "right" }}>Price</div>
                        </div>
                        {menuItems[activeCategory].items.map((item, i) => (
                            <div key={item.name} style={{
                                display: "flex", alignItems: "center", padding: "14px 20px",
                                borderBottom: i < menuItems[activeCategory].items.length - 1 ? "1px solid #F0E8E0" : "none",
                                background: i % 2 === 0 ? "white" : "#FFFAF5", transition: "background .15s", gap: 12,
                            }}
                                onMouseEnter={e => e.currentTarget.style.background = "#FFF3E0"}
                                onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? "white" : "#FFFAF5"}
                            >
                                <span style={{ fontSize: "1.5rem", flexShrink: 0 }}>{item.icon}</span>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                        <span style={{ fontFamily: "'Playfair Display',serif", fontWeight: 700, fontSize: "clamp(.9rem,2.5vw,1rem)", color: "#1a0a00" }}>{item.name}</span>
                                        {item.popular && (
                                            <span style={{ background: "#FF6B00", color: "white", fontSize: ".58rem", padding: "2px 7px", borderRadius: 20, fontWeight: 700, letterSpacing: ".05em", textTransform: "uppercase", flexShrink: 0 }}>⭐ Popular</span>
                                        )}
                                    </div>
                                    <div style={{ color: "#888", fontSize: ".8rem", marginTop: 2, lineHeight: 1.4 }}>{item.desc}</div>
                                </div>
                                <span className="price-badge">{item.price}</span>
                            </div>
                        ))}
                        <div style={{ background: "#FFF3E0", padding: "12px 20px", borderTop: "2px solid #FF6B00" }}>
                            <span style={{ fontSize: ".8rem", color: "#666" }}>⭐ = Customer favourite · All prices inclusive · Takeaway available</span>
                        </div>
                    </div>

                    {/* ── MENU CTA BUTTONS — inline, always visible ── */}
                    <div style={{ marginTop: 28, display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
                        <a href="tel:08249079497" style={{ textDecoration: "none" }}>
                            <button className="btn-call" style={{ width: "auto", padding: "13px 32px" }}>📞 Call: 082490 79497</button>
                        </a>
                        <a href={WA_LINK} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                            <button className="btn-wa" style={{ width: "auto", padding: "13px 32px" }}>💬 WhatsApp Bulk Order</button>
                        </a>
                    </div>
                </div>
            </section>

            {/* ── FOOD BLOGGERS ── */}
            <section id="featured" style={{ padding: "64px 20px", background: "#0f0500" }}>
                <div style={{ maxWidth: 1140, margin: "0 auto" }}>
                    <div style={{ textAlign: "center", marginBottom: 44 }}>
                        <div className="slabel">As Seen Online</div>
                        <h2 className="stitle" style={{ color: "white" }}>Food Bloggers<br /><span style={{ color: "#FF6B00" }}>Love Us! 🎉</span></h2>
                        <div className="divider" style={{ margin: "12px auto 12px" }} />
                        <p style={{ color: "rgba(255,255,255,.5)", fontSize: ".94rem", maxWidth: 440, margin: "0 auto" }}>Featured by top food creators — watch their videos right here!</p>
                    </div>
                    <div className="grid-reviewer">
                        {reviewers.map(r => (
                            <div key={r.handle} className="reviewer-card">
                                <div className="video-wrap">
                                    <iframe src={r.videoSrc} title={r.videoTitle} allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture" allowFullScreen />
                                </div>
                                <div style={{ padding: "18px 16px 16px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <div style={{ width: 36, height: 36, borderRadius: "50%", background: `${r.color}20`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.05rem" }}>{r.icon}</div>
                                            <div>
                                                <div style={{ fontWeight: 700, fontSize: ".92rem" }}>{r.handle}</div>
                                                <div style={{ fontSize: ".7rem", color: r.color, fontWeight: 700 }}>{r.platform}</div>
                                            </div>
                                        </div>
                                        <div style={{ textAlign: "right" }}>
                                            <div style={{ fontSize: ".73rem", color: "#888" }}>❤️ {r.likes}</div>
                                            <div style={{ fontSize: ".73rem", color: "#888" }}>💬 {r.comments}</div>
                                        </div>
                                    </div>
                                    <p style={{ color: "#333", fontSize: ".86rem", lineHeight: 1.65, fontStyle: "italic", marginBottom: 10 }}>"{r.quote}"</p>
                                    <div>{r.tags.map(t => <span key={t} className="tag">{t}</span>)}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="stat-banner" style={{ marginTop: 38, background: "linear-gradient(135deg,#FF6B00,#D4A017)", borderRadius: 14, padding: "22px 24px" }}>
                        {[["54.8K ❤️", "Instagram & YouTube Likes"], ["906 💬", "Comments"], ["147 ❤️", "rasoisaga Post"], ["4.2 ⭐", "Google Rating"]].map(([v, l]) => (
                            <div key={l} style={{ textAlign: "center" }}>
                                <div style={{ fontFamily: "'Playfair Display',serif", fontSize: "clamp(1.3rem,4vw,1.7rem)", color: "white", fontWeight: 900 }}>{v}</div>
                                <div style={{ fontSize: ".68rem", color: "rgba(255,255,255,.78)", letterSpacing: ".07em", textTransform: "uppercase", marginTop: 2 }}>{l}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── CUSTOMER REVIEWS ── */}
            <section style={{ padding: "64px 20px", background: "#FFF8F0" }}>
                <div style={{ maxWidth: 1140, margin: "0 auto" }}>
                    <div style={{ textAlign: "center", marginBottom: 36 }}>
                        <div className="slabel">Google Reviews</div>
                        <h2 className="stitle">What Customers Say</h2>
                        <div className="divider" style={{ margin: "12px auto 12px" }} />
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                            {[1, 2, 3, 4].map(i => <span key={i} className="star" style={{ fontSize: "1rem" }}>★</span>)}
                            <span style={{ color: "#FFB800", opacity: .35, fontSize: "1rem" }}>★</span>
                            <span style={{ fontWeight: 700, fontSize: "1rem", marginLeft: 4 }}>4.2</span>
                            <span style={{ color: "#999", fontSize: ".82rem" }}>· 401 Google Reviews</span>
                        </div>
                    </div>
                    <div className="grid-reviews">
                        {customerReviews.map(r => (
                            <div key={r.name} className="review-card">
                                <div style={{ display: "flex", gap: 10, marginBottom: 10, alignItems: "center" }}>
                                    <div className="avatar">{r.avatar}</div>
                                    <div>
                                        <div style={{ fontWeight: 700 }}>{r.name}</div>
                                        <div>{Array(r.rating).fill(0).map((_, i) => <span key={i} className="star" style={{ fontSize: ".8rem" }}>★</span>)}</div>
                                    </div>
                                </div>
                                <p style={{ color: "#555", fontSize: ".86rem", lineHeight: 1.65, fontStyle: "italic" }}>"{r.text}"</p>
                            </div>
                        ))}
                    </div>
                    <div style={{ textAlign: "center", marginTop: 28 }}>
                        <a
                            href="https://www.google.com/maps/place/New+Odia+Snacks+and+Sweets/@12.9066966,77.6032044,18z/data=!3m1!5s0x3bae14e21e4e7b55:0xc898c4c4d81155fb!4m8!3m7!1s0x3bae14e26e277787:0x1d041f9375ccc284!8m2!3d12.9057815!4d77.6090489!9m1!1b1!16s%2Fg%2F11g6qhjmgg?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                        >
                            <button className="btn-sf">⭐ Write a Google Review</button>
                        </a>
                    </div>
                </div>
            </section>

            {/* ── CONTACT + MAP ── */}
            <section id="contact" style={{ padding: "64px 20px", background: "#FFF3E0" }}>
                <div style={{ maxWidth: 1140, margin: "0 auto" }}>
                    <div style={{ textAlign: "center", marginBottom: 40 }}>
                        <div className="slabel">Find Us</div>
                        <h2 className="stitle">Visit Our Shop</h2>
                        <div className="divider" style={{ margin: "12px auto 0" }} />
                    </div>
                    <div className="grid-contact">
                        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                            {[
                                ["📍", "Address", "N.S Palya, 10/6 Road, Industrial Area, BTM Layout 2nd Stage, Bengaluru, Karnataka 560076"],
                                ["📞", "Phone", "082490 79497"],
                                ["🕙", "Hours", "8:00 AM – 3:00 PM & 5:00 PM – 10:00 PM · Daily"],
                                ["💰", "Price", "₹10 – ₹200 per person"],
                                ["👨‍👩‍👧", "For Everyone", "Kids' Menu · Walk-ins Welcome"],
                            ].map(([icon, title, content]) => (
                                <div key={title} className="info-row">
                                    <span style={{ fontSize: "1.25rem", flexShrink: 0 }}>{icon}</span>
                                    <div>
                                        <div style={{ fontWeight: 700, fontSize: ".7rem", letterSpacing: ".1em", textTransform: "uppercase", color: "#FF6B00", marginBottom: 2 }}>{title}</div>
                                        <div style={{ color: "#333", fontSize: ".84rem", lineHeight: 1.5 }}>{content}</div>
                                    </div>
                                </div>
                            ))}

                            {/* ── CALL — inline, always visible on all screens ── */}
                            <a href="tel:08249079497" style={{ textDecoration: "none" }}>
                                <button className="btn-call">📞 Call Now</button>
                            </a>

                            {/* ── WHATSAPP — inline, always visible on all screens ── */}
                            <a href={WA_LINK} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                                <button className="btn-wa">💬 WhatsApp for Bulk Orders</button>
                            </a>

                            <a href="https://maps.google.com/?q=New+Odia+Snacks+and+Sweets,NS+Palya,BTM+Layout+2nd+Stage,Bengaluru" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                                <button style={{ width: "100%", background: "transparent", color: "#1a0a00", border: "2px solid #1a0a00", padding: "13px", fontFamily: "'Lato',sans-serif", fontWeight: 700, letterSpacing: ".08em", fontSize: ".86rem", cursor: "pointer", borderRadius: 4, textTransform: "uppercase", transition: "all .2s" }}>
                                    📍 Open in Google Maps
                                </button>
                            </a>
                        </div>

                        <div className="map-box" style={{ borderRadius: 14, overflow: "hidden", boxShadow: "0 4px 22px rgba(0,0,0,.12)", height: 440 }}>
                            <iframe title="Shop Location" width="100%" height="100%" style={{ border: 0 }} loading="lazy" allowFullScreen referrerPolicy="no-referrer-when-downgrade"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.030171013958!2d77.60646861187846!3d12.905781487350918!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14e26e277787%3A0x1d041f9375ccc284!2sNew%20Odia%20Snacks%20and%20Sweets!5e0!3m2!1sen!2sin!4v1772286477454!5m2!1sen!2sin" />
                        </div>
                    </div>
                </div>
            </section>

            {/* ── FOOTER ── */}
            <footer style={{ background: "#0f0500", padding: "36px 20px", textAlign: "center" }}>
                <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
                    <img src={logo} alt="New Odia Snacks & Sweets" className="footer-logo" />
                </div>
                <div style={{ fontFamily: "'Playfair Display',serif", fontWeight: 900, color: "white", fontSize: "1.25rem", marginBottom: 6 }}>
                    New Odia Snacks & Sweets
                </div>
                <div style={{ color: "rgba(255,255,255,.36)", fontSize: ".78rem", marginBottom: 10 }}>
                    BTM Layout, Bengaluru · 8am–3pm & 5pm–10pm · 082490 79497
                </div>
                <div style={{ color: "rgba(255,107,0,.48)", fontSize: ".72rem" }}>
                    Authentic Flavours of Odisha ✦ Proudly serving Bengaluru
                </div>
                <div style={{ height: 20 }} />
            </footer>
        </div>
    );
}